export enum AuctionType {
  Public = 'PUBLIC',
  InvitedOnly = 'INVITED_ONLY',
};
export interface AuctionModel {
  id: number;
  status: string;
  type: AuctionType;
  started_at: string;
  ended_at: string;
  created_at: string;
  updated_at: string;
  product_id: number;
  origin_price: number;
  sell_price: number;
  link: string;
  staff_id: number;
  auction_config: {
    prices: number[];
  };
  ended_time_at: string;
  has_invited?: boolean;
}
